// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"_3-L4p","rc-tabs-bar":"QXgWP","rc-tabs-tab":"XDymA","rc-tabs-tab-active":"ZykR6","terms":"jEYIc","orderHistory-navigation":"aGwS8"};